export default {
  form: {
    agreement: {
      label:
        'I acknowledge that providing my electronic approval is equivalent to signing this document and I understand that my electronic signature is binding.',
    },
    signed_by: {
      label: 'Name',
      placeholder: 'Name',
    },
    signer_first_name: {
      label: 'First name',
      placeholder: 'First name',
    },
    signer_last_name: {
      label: 'Last name',
      placeholder: 'Last name',
    },
    recipient_email: {
      label: 'Recipient email address',
      placeholder: 'Enter email address',
    },
    send_to_email: {
      label: 'Send contract to the owner via email ({{email}})',
    },
    additional_locations: {
      label: 'Additional locations',
      placeholder: 'Search for a location to add',
    },
    special_agreements: {
      label: 'Special agreements',
      placeholder: 'Enter any special agreements',
    },
  },
  labels: {
    name: 'Name',
    date: 'Date',
  },
  buttons: {
    sign_in_person: 'Sign here with the owner',
    back: 'Back',
    edit_contract: 'Edit contract',
    skip: 'Skip',
    sign: 'Sign',
    init_sign: 'Create contract and Send',
    redo: 'Redo',
    continue: 'Continue',
    preview: 'Preview',
    submit: 'Submit',
  },
  toasts: {
    failed_to_preview_contract: 'Failed to preview the contract',
    contract_signing_pending: 'Hold on, we are initiating your contract...',
    failed_to_sign_contract: 'Failed to initiate the contract ⁉️',
    contract_got_signed: 'Contract got initiated 👌',
  },
  in_person_signing: {
    description:
      'The owner has received this link by email and can sign remotely. If the owner is with you now, open the signing page here.',
  },
  signature_link: {
    label: 'Signature link (same link sent to the recipient via email)',
    copy: 'Copy',
    copied: 'Signature link copied to clipboard',
  },
  header: 'Create contract',
  description: 'Please review the contract details and enter the email address to which the contract should be sent.',
};
